import React from 'react'
import sedanImage from '../img/car1.jpg'; 
import fieldCarImage from '../img/car2.jpg'; 
import suvImage from '../img/car3.jpg'; 
import coupeImage from '../img/car4.jpg'; 
import convertibleImage from '../img/car15.jpg'; 
import truckImage from '../img/car1.jpg'; 
import '../style/Image.css'
const Image = () => {
  return (
    <div>
      <div class="container my-5">

    <div class="row g-4">
       
        <div class="col-md-8">
            <div class="bento-item bento-tall">
                <div class="bento-label">Featured</div>
                <img src={sedanImage} alt="Sedan Car"/>
                <div class="bento-content">
                    <h3>Sedan</h3>
                    <p>Comfort and luxury for your journeys.</p>
                </div>
            </div>
        </div>
 
        <div class="col-md-4">
            <div class="row g-4">
                <div class="col-12">
                    <div class="bento-item">
                        <div class="bento-label">Popular</div>
                        <img src={fieldCarImage} alt="Field Car"/>
                        <div class="bento-content">
                            <h4>Field Car</h4>
                        </div>
                    </div>
                </div>
                <div class="col-12">
                    <div class="bento-item">
                        <div class="bento-label">Trendy</div>
                        <img src={suvImage} alt="SUV"/>
                        <div class="bento-content">
                            <h4>SUV</h4>
                        </div>
                    </div>
                </div>
            </div>
        </div>
  
        <div class="col-md-4">
            <div class="bento-item">
                <div class="bento-label">Luxury</div>
                <img src={coupeImage} alt="Coupe"/>
                <div class="bento-content">
                    <h4>Coupe</h4>
                </div>
            </div>
        </div>
        <div class="col-md-4">
            <div class="bento-item">
                <div class="bento-label">Convertible</div>
                <img src={convertibleImage} alt="Convertible"/>
                <div class="bento-content">
                    <h4>Convertible</h4>
                </div>
            </div>
        </div>
        <div class="col-md-4">
            <div class="bento-item">
                <div class="bento-label">Powerful</div>
                <img src={truckImage} alt="Truck"/>
                <div class="bento-content">
                    <h4>Truck</h4>
                </div>
            </div>
        </div>
    </div>
</div>

    </div>
  )
}

export default Image
